import {Observable, shareReplay} from 'rxjs';
import {distinctUntilChanged, map, startWith, filter, withLatestFrom, switchMap} from 'rxjs/operators';
import {popupUtil} from '@/helper/popup';
import {timeUtil} from '@/helper/time';
import {IP_RESTRICTED_CODE} from '@/emum';
import {userApi} from '@/api/user';
import {browser$} from '@/streams/browser';
import MessageDialog from '@/modules/popups/MessageDialog.svelte';
import {shouldTip, writeLastTipTime} from './storage';
import lang from '@/modules/homepage/HomePage.lang';
import gLang from './IpRestricted.lang';

interface GeoV2Config {
  code: number;
  msg: string;
  matchesRule: boolean;
  country: string;
  countryCode: string;
  city: string;
  startTime: number;
  divisions: any[];
  suggestionAction: number;
}

export const ipRestrictedConfig$: Observable<Partial<GeoV2Config>> = browser$.pipe(
  switchMap(() => <Promise<{data: GeoV2Config}>>userApi.getPublicGeoV2()),
  map((res) => res?.data || {}),
  shareReplay(1)
);

/**
 * 封禁ip，预先通知时间段
 */
export const isIpPreRestricted$ = ipRestrictedConfig$.pipe(
  map((config) => config.code === IP_RESTRICTED_CODE.WARNING),
  startWith(false),
  distinctUntilChanged()
);

/**
 * 封禁ip
 */
export const isIpRestricted$ = ipRestrictedConfig$.pipe(
  map((config) => config.code === IP_RESTRICTED_CODE.RESTRICTED),
  startWith(false),
  distinctUntilChanged()
);

/**
 * 封禁ip
 */
export const isIpRestrictedRegister$ = ipRestrictedConfig$.pipe(
  map((config) => config.code === IP_RESTRICTED_CODE.REGISTER_FORBIDDEN),
  startWith(false),
  distinctUntilChanged()
);

export function subPreRestrictedDialog(LG) {
  isIpPreRestricted$.pipe(filter(Boolean), withLatestFrom(ipRestrictedConfig$)).subscribe(([v, config]) => {
    if (!shouldTip()) {
      return;
    }
    writeLastTipTime();
    popupUtil.create(MessageDialog, {title: LG(lang.Note), message: LG(gLang.preRestrictedMsg, {Email: `<a href="mailto:support@phemex.zendesk.com">support@phemex.zendesk.com</a>`, Date: timeUtil.formatUTCDate(config.startTime)})});
  });
}

/**
 * 是否为美国IP
 */
export const isUSIp$ = ipRestrictedConfig$.pipe(
  map((config) => config.countryCode === 'US'),
  startWith(false),
  distinctUntilChanged()
);
